import { cn } from "@/lib/utils"

type NodeStateTone =
	| "neutral"
	| "muted"
	| "accent"
	| "success"
	| "warning"
	| "danger"

const STATE_FILL_BY_TONE: Record<NodeStateTone, string> = {
	neutral: "var(--node-state-default)",
	muted: "var(--node-state-unconnected)",
	accent: "var(--node-selection)",
	success: "var(--node-state-computed)",
	warning: "var(--node-state-computing)",
	danger: "var(--node-state-error)",
}

export function NodeStateDot({
	tone,
	className,
}: {
	tone: NodeStateTone
	className?: string
}) {
	return (
		<span
			data-oblique-state-dot
			className={cn(
				"relative block size-[10px] shrink-0 rounded-full bg-[var(--node-state-ring)] shadow-[0_0_1px_rgba(0,0,0,0.25)]",
				className,
			)}
		>
			<span
				className="absolute inset-[2px] rounded-full"
				style={{ backgroundColor: STATE_FILL_BY_TONE[tone] }}
			/>
		</span>
	)
}
